export { default } from "./StreamsTagsText";
